<template>
  <v-form>
    <v-container class="py-0">
      <v-row>
        <v-col md="9" cols="12">
          <v-select v-model="newBannerData.type" :items="types" item-text="label" item-value="value" :label="$t('type_field')" persistent-hint single-line required outlined />
        </v-col>
        <v-col md="3" cols="12">
          <v-switch v-model="newBannerData.new" :label="$t('is_new')" />
        </v-col>
        <v-col v-if="item.id && item.image_url" md="3" cols="12">
          <v-img :src="item.image_url" />
        </v-col>
        <v-col cols="12">
          <v-file-input :label="$t('upload_banner_image')" truncate-length="35" @change="updateImage" />
        </v-col>
        <v-col md="6" cols="12">
          <v-menu ref="date_start_menu" v-model="date_start_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="newBannerData.start_date" color="purple" :label="$t('start_date')" readonly v-bind="attrs" required outlined v-on="on" />
            </template>
            <v-date-picker v-model="newBannerData.start_date" :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)" />
          </v-menu>
        </v-col>
        <v-col md="6" cols="12">
          <v-menu ref="date_end_menu" v-model="date_end_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="newBannerData.end_date" color="purple" :label="$t('end_date')" readonly v-bind="attrs" required outlined v-on="on" />
            </template>
            <v-date-picker v-model="newBannerData.end_date" :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)" />
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
export default {
  name: 'GeneralTab',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    newBannerData: {},
    date_start_menu: false,
    date_end_menu: false,
    types: [
      { label: 'landing_unique_offer', value: 'landing_unique_offer' },
    ],
  }),
  mounted () {
    this.newBannerData = this.item
  },
  methods: {
    updateImage (file) {
      this.newBannerData.image = file
    },
  },
}
</script>
